import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { languageDirection } from 'src/utils/i18n';

function MuiRTL({ children }) {
	const { i18n } = useTranslation();

	const cache = createCache(
		languageDirection(i18n.language) === 'rtl'
			? {
					key: 'muirtl',
					stylisPlugins: [prefixer, rtlPlugin as any],
			  }
			: {
					key: 'muiltr',
			  }
	);

	return <CacheProvider value={cache}>{children}</CacheProvider>;
}

export default MuiRTL;
